<template>
    <component v-if="product" :is="product === undefined ? 'div' : 'BCard'">
        <BAlert variant="danger" :show="product === undefined">
            <h4 class="alert-heading"> Error fetching product data </h4>
        </BAlert>

        <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <TextInputValidated vsName="Code" :vsModel.sync="product.code" vsMd="4" vsRequired vsRules="required"/>
                    <TextInputValidated vsName="Name" :vsModel.sync="product.name" vsMd="4" vsRequired vsRules="required"/>
                    <vSelectValidated vsName="Family" :vsModel.sync="product.family_id" :vsReduce="fam=>fam.id" :vsOptions="families" vsLabel="name" vsMd="4" vsRequired vsRules="required"/>
                    <NumberInputValidated vsName="Amount" :vsModel.sync="product.amount" vsMd="4" vsRequired vsRules="required"/>
                    <vSelectValidated vsName="Tax" :vsModel.sync="product.tax_id" :vsReduce="tax=>tax.id" :vsOptions="taxes" vsLabel="name" vsMd="4" vsRequired vsRules="required"/>
                    <NumberInputValidated vsName="Stock" :vsModel.sync="product.stock" vsMd="4" vsRequired vsRules="required"/>
                    <vSelectValidated vsName="Sucursal" :vsModel.sync="product.group_id" vsMd="4" :vsOptions="groups" vsLabel="name" vsRequired vsRules="required" :vsReduce="group => group.id" v-if="groups && groups.length>1" />
                    <TextareaValidated vsName="Observations" :vsModel.sync="product.observations"/>
                    <CheckboxValidated vsName="pit" :vsModel.sync="product.pit" vsLabel="IRPF" />
                    <CheckboxValidated vsName="show_tpv" :vsModel.sync="product.show_tpv" vsLabel="Show in TPV" />
                    <CheckboxValidated vsName="show_student_tpv" :vsModel.sync="product.show_student_tpv" vsLabel="Show in student TPV" />
                </BRow>

                <!-- Action Buttons -->
                <BButton variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'products' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
    </component>
</template>

<script>
import { BAlert, BCard, BButton, BForm, BRow, BCol, BFormInvalidFeedback, BFormTextarea, BFormInput, BFormGroup } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { onUnmounted, ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import TextareaValidated from '@/components/forms/TextareaValidated.vue'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
import productModule from '../productModule'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import router from '@/router'
import store from '@/store'
import axios from '@axios'


export default {
    components: { NumberInputValidated, TextInputValidated, vSelectValidated, TextareaValidated, BAlert, BCard, BButton, BForm, BRow, BCol, BFormInvalidFeedback, BFormTextarea, BFormInput, BFormGroup, vSelect, ValidationObserver, ValidationProvider, CheckboxValidated },
    setup(){
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const PRODUCTS_MODULE = 'products'
        const product = ref(null)
        const families = ref([])
        const taxes = ref([])
        const groups=ref([])


        const onSubmit = function() {
            this.$refs.form.validate().then(success => {
                if(success) {
                    store.dispatch('products/updateProduct', JSON.parse(JSON.stringify(product.value)))
                        .then(response => { 
                            this.$router.push({ name: 'products' }) 
                    })
                        .catch(error => { errorToast('Can\'t update products') })
                }
            })
        }

        if (!store.hasModule(PRODUCTS_MODULE)) store.registerModule(PRODUCTS_MODULE, productModule)

        onUnmounted(() => {
            if (store.hasModule(PRODUCTS_MODULE)) store.unregisterModule(PRODUCTS_MODULE)
        })

        store.dispatch('products/fetchProduct', { id: router.currentRoute.params.id }).then(response => {
            product.value = response.data.product
            families.value = response.data.families
            taxes.value = response.data.taxes
        })

        axios.get('groups').then(response => {
            groups.value=response.data.groups
        })

        return {
            getValidationState,
            onSubmit,
            product,
            families,
            taxes,
            groups
        }
    }
}
</script>

<style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
</style>
